Ext.define('SA.model.CustomLocationStringId', {
    singleton: true,

    forInteger(integer) {
        return `customLocation:${integer}`;
    },

    getInteger(string) {
        var integerString = SA.String.remove(string, 'customLocation:');

        return Number.parseInt(integerString);
    },

    match(id) {
        return /^customLocation:\d+$/.test(id);
    }
});